// rideIntro.ts
// ============
//
// Wave 14ch: One-time intro popup wenn der User zum ersten Mal RIDE drückt.
//
// Hintergrund: GPS-Aufzeichnung pausiert sobald das Display ausgeht (iOS-
// und Android-Policy für PWAs — wir können einen wakeLock setzen, aber
// nicht garantieren). User die nicht wissen dass sie das Display anlassen
// müssen, ärgern sich am Ende der Tour über Track-Lücken.
//
// Lösungs-Mix:
//   1) Pocket-Mode: Touch-Sperre + Always-On-Display-Tricks, Akku-schonend.
//   2) Dieser Hinweis erklärt das einmalig.
//   3) Checkbox "don't show again" → in localStorage merken, fertig.
//
// Sync-strategie: localStorage-Key ist NICHT in SYNCED_PREF_KEYS — pro
// Gerät einmal anzeigen ist intentional (jeder neue Browser-Install soll
// die Info einmal sehen). User entscheidet pro Gerät selbst.

const STORAGE_KEY = 'adt_ride_intro_dismissed';

/** True wenn das Popup beim nächsten startRide gezeigt werden soll. */
export function shouldShowRideIntro(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) !== '1';
  } catch {
    // SSR / private mode / quota — Popup einmal pro Session zeigen ist
    // immer noch besser als gar nicht.
    return true;
  }
}

/** Merkt sich dass der User das Popup gesehen + dismissed hat. */
export function dismissRideIntroForever(): void {
  try {
    localStorage.setItem(STORAGE_KEY, '1');
  } catch {
    /* SSR / quota — schadet nicht, popup kommt halt nochmal */
  }
}

/** Resette die Dismissal — fürs manuelle Testen / Re-Show-Button im
 *  Profile-Menü (vorerst nicht gebraucht, aber export'd damit eine
 *  spätere "Show intro again"-Action das aufrufen kann). */
export function resetRideIntro(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* egal */
  }
}
